import { useController } from "react-hook-form";
import { Switch } from "antd";
import { FormSwitchProps } from "./Form.types";
import FormField, { useFormField } from "./FormField/FormField";
import { ForwardedRef, forwardRef } from "react";

export const FormSwitch = forwardRef((props: FormSwitchProps, ref: ForwardedRef<HTMLElement>) => {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <Switch {...childProps} {...field} checked={field.value} ref={ref} />
    </FormField>
  );
});
